<template>
  <div>
    <setting-menu></setting-menu>
    <main class="c-app-content is-sidebar-tiny">
      <div class="c-container-inner">
        <div class="row">
          <div class="c-btn-mobile js-btn-mobile"><i class="fa fa-bars"></i>{{ $t('expandMenu') }}</div>
          <div class="col-lg-3 c-sidebar-main">
            <div class="c-sidebar-menu">
              <ul>
                <li>
                  <label>{{ $t('accountInfo') }}</label>
                  <ul>
                    <router-link to="/setting/profile" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('accountInfo') }}</router-link></li>
                    </router-link>
                    <router-link to="/setting/device-token" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('device') }}</router-link></li>
                    </router-link>
                    <router-link to="/setting/other-device" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('signInWithOtherDevice') }}</router-link></li>
                    </router-link>
                  </ul>
                </li>
                <li v-if="$store.state.user.permissions.includes('userManageAll')">
                  <label>{{ $t('rolesAndAccounts') }}</label>
                  <ul>
                    <router-link to="/setting/group" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('userGroups') }}</router-link></li>
                    </router-link>
                    <router-link to="/setting/roles" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('roles') }}</router-link></li>
                    </router-link>
                    <router-link to="/setting/user-account" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('userAccounts') }}</router-link></li>
                    </router-link>
                  </ul>
                </li>
                <li>
                  <label>{{ $t('communication') }}</label>
                  <ul v-if="$store.state.user.permissions.includes('phoneSetup')">
                    <router-link to="/setting/phone" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('phoneComm') }}</router-link></li>
                    </router-link>
                  </ul>
                  <ul v-if="$store.state.user.permissions.includes('smsSetup')">
                    <router-link to="/setting/sms" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('smsComm') }}</router-link></li>
                    </router-link>
                  </ul>
                  <ul>
                    <router-link to="/setting/email" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('emailComm') }}</router-link></li>
                    </router-link>
                  </ul>
                  <ul v-if="$store.state.user.permissions.includes('blackListContactSetup')">
                    <router-link to="/setting/black-list-contact" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('blackListContact') }}</router-link></li>
                    </router-link>
                  </ul>
                </li>
                <li v-if="$store.state.user.permissions.includes('webhookSetup') || $store.state.user.permissions.includes('tokenSetup')">
                  <label>{{ $t('integrations') }}</label>
                  <ul v-if="$store.state.user.permissions.includes('googleSheetSetup')">
                    <router-link to="/setting/google-sheet" v-slot="{href, isExactActive}">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('googleSheet') }}</router-link></li>
                    </router-link>
                  </ul>
                  <ul>
                    <router-link to="/setting/token" v-slot="{href, isExactActive}"
                                 v-if="$store.state.user.permissions.includes('tokenSetup')">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('token') }}</router-link></li>
                    </router-link>
                  </ul>
                  <ul>
                    <router-link to="/setting/web-hook" v-slot="{href, isExactActive}"
                                 v-if="$store.state.user.permissions.includes('webHookSetup')">
                      <li :class="[isExactActive ? 'active' : '']"><router-link :to="href">{{ $t('webHook') }}</router-link></li>
                    </router-link>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import SettingMenu from "../../components/SettingMenu";
import $ from 'jquery';

export default {
  components: {SettingMenu},
  mounted: function () {
    //js expand menu setting
    $('.js-btn-mobile').on('click', function (e) {
      e.preventDefault();
      var sidebar = $('.c-sidebar-main');
      if (sidebar.hasClass('active')) {
        sidebar.removeClass('active').slideUp();
      } else {
        sidebar.addClass('active').slideDown();
      }
    });

    //close setting menu in mobile
    $('.c-sidebar-menu a').on('click', function (e) {
      var sidebar = $('.c-sidebar-main');
      var viewportGlobal = $(window).width();
      if (e.target == this && viewportGlobal < 768) {
        sidebar.removeClass('active').slideUp();
      }
    });
  },
  computed: {
    showUserMenu() {
      let permissions = [
        'userCreateGroup', 'userCreateAll',
        'userUpdateGroup', 'userUpdateAll',
        'userPasswordResetGroup', 'userPasswordResetAll',
        'userDeactivateGroup', 'userDeactivateAll',
        'userActivateGroup', 'userActivateAll',
      ]
      if (this.$store.state.user.permissions.find(p => permissions.includes(p))) {
        return true
      }
      return false;
    }
  }
}
</script>

<style scoped>

</style>